import { render, staticRenderFns } from "./BlockedVisitors.vue?vue&type=template&id=9fcbd846&scoped=true"
import script from "./BlockedVisitors.vue?vue&type=script&lang=js"
export * from "./BlockedVisitors.vue?vue&type=script&lang=js"
import style0 from "./BlockedVisitors.vue?vue&type=style&index=0&id=9fcbd846&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fcbd846",
  null
  
)

export default component.exports